import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory'
import { ApolloClient } from 'apollo-client'
import { setContext } from 'apollo-link-context'
import { createHttpLink } from 'apollo-link-http'

import fragmentTypes from '@/graphql-fragment-types'
import VueApollo from 'vue-apollo'
import store from './store'

// HTTP connection to the API
const httpLink = createHttpLink({
  // You should use an absolute URL here
  uri: '/api/graphql',
})

const authLink = setContext((_, { headers, ...otherSettings }) => {
  // copied and adapted from https://www.graphile.org/postgraphile/security/
  // get the authentication token from wherever you store it
  const token = store.getters.authToken
  // return the headers to the context so httpLink can read them
  if (token) {
    return {
      ...otherSettings,
      headers: { ...headers, Authorization: `Bearer ${token}` },
    }
  } else {
    return { ...otherSettings, headers }
  }
})

// Cache implementation
export const apolloCache = new InMemoryCache({
  // dataIdFromObject: object => object.id || null,
  // see https://graphql-code-generator.com/docs/plugins/fragment-matcher
  fragmentMatcher: new IntrospectionFragmentMatcher({
    introspectionQueryResultData: fragmentTypes,
  }),
})

// Create the apollo client
export const apolloClient = new ApolloClient({
  cache: apolloCache,
  connectToDevTools: true,
  link: authLink.concat(httpLink),
})

export default new VueApollo({
  defaultClient: apolloClient,
})
